<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <div :class="sectionClass">
    <label v-if="label" :for="id" :class="labelClass">{{ label }}</label>
    <div class="input-group" :class="{ 'p-invalid': validation?.$error }">
      <span v-if="prefix" class="input-group-addon" :class="prefix">
        <slot name="prefix"></slot>
      </span>
      <input
        type="number"
        :id="id"
        class="input-group-field w-full rounded inputnumfocus"
        :value="modelValueComputed"
        :disabled="disabled"
        :placeholder="placeholder"
        :min="min"
        :max="max"
        :class="{ 'p-invalid': validation?.$error }"
        :aria-describedby="`${id}-help`"
        @input="$emit('update:modelValue', $event.target.valueAsNumber || 0)"
      />
      <div class="input-group-controls">
        <button
          type="button"
          class="increment-btn"
          :disabled="disabled || (max !== null && modelValueComputed >= max)"
          @click="increment"
        >
          <i class="pi pi-chevron-up ar-color"></i>
        </button>
        <button
          type="button"
          class="decrement-btn"
          :disabled="disabled || (min !== null && modelValueComputed <= min)"
          @click="decrement"
        >
          <i class="pi pi-chevron-down ar-color"></i>
        </button>
      </div>
      <span v-if="suffixEl" class="input-group-addon" :class="suffixEl">
        <slot name="suffix"></slot>
      </span>
    </div>
    <span
      v-if="
        validation?.$error &&
        validation.required &&
        validation.required.$invalid
      "
      :id="`${id}-help`"
      class="p-error text-left mt-2"
    >
      {{ validation.required.$message.replace("Value", PropName) }}
    </span>
    <span
      v-if="
        validation?.$error &&
        validation.minValue &&
        validation.minValue.$invalid
      "
      :id="`${id}-help`"
      class="p-error text-left mt-2"
    >
      {{ validation.minValue.$message.replace("Value", PropName) }}
    </span>
    <span
      v-if="
        validation?.$error &&
        validation.maxValue &&
        validation.maxValue.$invalid
      "
      :id="`${id}-help`"
      class="p-error text-left mt-2"
    >
      {{ validation.maxValue.$message.replace("Value", PropName) }}
    </span>
  </div>
</template>

<script>
export default {
  props: {
    labelClass: {
      type: String,
      default: "form-label",
    },
    PropName: {
      type: String,
      default: "",
    },
    sectionClass: {
      type: String,
      default: "field",
    },
    id: {
      type: String,
      required: true,
      default: "",
    },
    label: {
      type: String,
      required: false,
      default: "",
    },
    validation: {
      type: Object,
      required: false,
    },
    modelValue: {
      type: [Number, String],
      default: 0,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    placeholder: {
      type: String,
      default: "",
    },
    prefix: {
      type: String,
      default: "",
    },
    suffix: {
      type: String,
      default: "",
    },
    min: {
      type: Number,
      default: null,
    },
    max: {
      type: Number,
      default: null,
    },
  },
  computed: {
    modelValueComputed: {
      get() {
        return this.modelValue === null ? 0 : this.modelValue;
      },
      set(value) {
        this.$emit("update:modelValue", value);
      },
    },
    suffixEl() {
      return this.suffix ? this.suffix : "";
    },
  },
  methods: {
    increment() {
      const newValue = (this.modelValueComputed || 0) + 1;
      if (this.max === null || newValue <= this.max) {
        this.$emit("update:modelValue", newValue);
      }
    },
    decrement() {
      const newValue = (this.modelValueComputed || 0) - 1;
      if (this.min === null || newValue >= this.min) {
        this.$emit("update:modelValue", newValue);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.input-group {
  display: flex;
  align-items: center;
  border: 1px solid #c0c0bc;
  border-radius: 0.25rem;
  overflow: hidden;

  &.p-invalid {
    border-color: #dc3545;
  }
}
.input-group-field:enabled:focus {
  outline: none !important;
}
.input-group-field {
  color: #21211f !important;
  font-size: 16px;
  resize: none;
  box-shadow: none;
  border: none;
  font-weight: 500;
  line-height: 1;
  font-family: "voyado Text";
  padding: 0.5rem;
  min-width: 36px;
  background-color: transparent;

  // &:enabled:focus {
  //   outline: 0 none;
  //   outline-offset: 0;
  //   box-shadow: none !important;
  //   outline: 2px solid #222222 !important;
  //   border-style: double !important;
  // }

  /* Hide default number input spinners */
  &::-webkit-inner-spin-button,
  &::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
  -moz-appearance: textfield;

  &.inputnumfocus:enabled:focus {
    /* Add your custom focus styles here if needed */
  }
}

.input-group-addon {
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #ffff;
  color: #21211f;
  font-size: 16px;
  font-family: "voyado Text";
  min-width: 36px;
  margin-left: 16px;
}

.input-group-controls {
  display: flex;
  flex-direction: column;
  height: 100%;
  border-left: 1px solid #c0c0bc;
}

.increment-btn,
.decrement-btn {
  background-color: #ffffff;
  color: #21211f;
  border: none;
  padding: 0.25rem 0.5rem;
  font-size: 14px;
  cursor: pointer;
  transition: background-color 0.2s;
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover:not(:disabled) {
    background-color: #e9ecef;
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }

  .pi {
    font-size: 12px; /* Adjust icon size as needed */
  }

  &.up-btn .ar-color,
  &.down-btn .ar-color {
    color: #21211f; /* Example color, adjust as needed */
  }
}

.increment-btn {
  border-bottom: 1px solid #c0c0bc;
}
</style>
